// extracted by mini-css-extract-plugin
export var arrows = "_22-6";
export var decrementer = "_22-a";
export var disabled = "_22-4";
export var error = "_22-1";
export var hiddenText = "_22-b";
export var incrementer = "_22-9";
export var input = "_22-8";
export var inputWrapper = "_22-0";
export var leadingIcon = "_22-c";
export var readonly = "_22-3";
export var regular = "_22-7";
export var small = "_22-5";
export var warning = "_22-2";